import {Box} from '@indoqa/style-system'
import {AlignedContentPanel} from '../../commons/components/content/AlignedContentPanel'
import {ContentPanel} from '../../commons/components/content/ContentPanel'
import {Pool} from '../../commons/idqsa/idqsa'
import {ContentNode} from '../../commons/types/ContentNode'
import {ArBookMetaComponent} from './ArBookMetaComponent'

interface Props {
  bookId: string
  contentNode: ContentNode | null
  paraId: string
  elementId?: string | null
}

// Note: The outer box leaves room beside the content for the Marginalien (see MARG_ASIDE_MIN_CONTAINER_WIDTH
// in DigitalCSSRules.ts)
export const ArBookContentPanel = ({contentNode, paraId, elementId}: Props) => {
  return (
    <Box maxWidth={1260} fullWidth>
      <AlignedContentPanel navShown={true} maxWidth={1000}>
        <ContentPanel
          contentNode={contentNode}
          currentNodeId={{id: paraId}}
          scrollToElementId={elementId}
          enableLawLinks
          disablePrinting
          trackingInfo={{pool: Pool.ARFBR, resultItemId: paraId}}
        />
        <ArBookMetaComponent meta={contentNode?.meta} />
      </AlignedContentPanel>
    </Box>
  )
}
